import { DirectiveBinding } from 'vue';
import Tooltip from 'bootstrap/js/dist/tooltip';

export default {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    const modifiers = Object.keys(binding.modifiers);
    const placement = modifiers[0] || 'auto';

    // Создаём instance только если есть текст
    if (binding.value && binding.value.trim() !== '') {
      const tooltipInstance = new Tooltip(el, {
        title: binding.value,
        placement: placement,
        trigger: 'hover focus',
      });

      // Сохраняем instance на элементе для доступа в updated/unmounted
      (el as any)._tooltipInstance = tooltipInstance;
    }
  },

  updated(el: HTMLElement, binding: DirectiveBinding) {
    const instance = (el as any)._tooltipInstance as Tooltip | undefined;
    const newContent = binding.value?.trim() || '';

    if (newContent === '') {
      // Если контент пустой, уничтожаем instance (удаляет стрелку)
      if (instance) {
        instance.dispose();
        (el as any)._tooltipInstance = undefined;
      }
      el.removeAttribute('title'); // На всякий случай убираем атрибут
    } else {
      if (instance) {
        // Обновляем контент
        instance.setContent({
          '.tooltip-inner': newContent,
        });
      } else {
        // Instance ещё нет — создаём
        const tooltipInstance = new Tooltip(el, {
          title: newContent,
          placement: Object.keys(binding.modifiers)[0] || 'auto',
          trigger: 'hover focus',
        });
        (el as any)._tooltipInstance = tooltipInstance;
      }
    }
  },

  unmounted(el: HTMLElement) {
    const instance = (el as any)._tooltipInstance as Tooltip | undefined;
    if (instance) {
      instance.dispose();
    }
    (el as any)._tooltipInstance = undefined;
  },
};
